<template>
  <pbc-overlay @close='onClose' @done='onSave'>
    <text-editing v-if='component.type === "text"'
                :component='shadowComponent'
                :transform='transform'
                :transforms-and-source='transformsAndSource'
                :render-tools='renderTools'
                class='grow'
                :partutil='partutil' />

    <div v-else class="grow flex flex-col overflow-hidden">
      <div class="flex flex-row justify-center flex-none h-16 mb-2">
        <condensed  :component='shadowComponent'
                    :transform='transform'
                    :transforms-and-source='transformsAndSource'
                    :partutil='partutil'
                    :disable-icon='true'
                    class='flex-none w-32'
                    :treeutil='treeutil' />
      </div>

      <unified-select :render-tools='renderTools'
                   :transforms-and-source='transformsAndSource'
                   :partutil='partutil'
                   :holder-data='holderData'
                   :layers='layers'
                    class='overflow-y-auto grow'
                   :selected-layers='selectedLayers'
                   @select-sticker='onSelectSticker'
                   @select-video='onSelectAnimation'
                   @select-pack='onSelectPack'
                   @select-uploaded-image='onSelectUploadedImage' />

    </div>


  </pbc-overlay>
  
</template>
<script>
import Condensed from '@components/molecules/Condensed.vue';
import { cloneDeep } from 'lodash';
import TextEditing from '@/components/editing/textEditing.vue';
import UnifiedSelect from '@ui/molecules/UnifiedSelect.vue';
export default {
  props:{
    component: {
      type:Object,
      required:true
    },
    transform: {
      type:Object,
      required:true
    },
    transformsAndSource: {
      type:Object,
      required:true
    },
    renderTools: {
      type:Object,
      required:true
    },
    partutil: {
      type:Object,
      required:true
    },
    selectionsData: {
      type:Array,
      required:true
    },
    holderData: {
      type:Object,
      required:true
    },
    selectedLayers: {
      type:Object,
      required:true
    },
    layers: {
      type: Object,
      required: true
    }
  },
  data() {
    const shadowComponent = cloneDeep(this.component);
    const ov = cloneDeep(this.component);
    const treeutil = this.partutil.getTreeUtil();
    return {
      shadowComponent,
      ov,
      treeutil
    }
  },
  methods: {
    onSelectSticker(animation) {
      console.log('select sticker', animation);
      this.onUpdate({
        type:'animation',
        data:animation
      });
    },
    onSelectAnimation(animation) {
      console.log('select video', animation);
      this.onUpdate({
        type:'animation',
        data:animation
      });
    },
    onSelectPack(data) {
      console.log('select pack', data);
      this.onUpdate({
        type:'spritesheet',
        data
      });
    },
    onSelectUploadedImage(data) {
      console.log('upload image', data);
      this.onUpdate({
        type:'upload',
        data:{image:data}
      });
    },
    onUpdate({type,data}) {
      const ov = this.ov;
      console.log('selected', type, data);
      if (type === 'animation') {
        const animation = data;
        const sprite = this.shadowComponent;
        this.$set(this.shadowComponent, 'anim', true);
        this.$set(this.shadowComponent, 'anims',[{
          frames:JSON.parse(animation.frames),
          loopByDefault: animation.loopByDefault,
          timePerFrame: animation.timePerFrame
        }]);
        this.$set(this.shadowComponent, 'atlas',sprite.anims[0].frames[0].atlas);
        this.$set(this.shadowComponent, 'sprite',sprite.anims[0].frames[0].texture);
        this.$set(this.shadowComponent, 'texture',sprite.anims[0].frames[0].texture);
        this.$set(this.shadowComponent, 'firstLoad',true);
      } else if (type === 'upload') {
        this.$set(this.shadowComponent, 'anim', false);
        this.$set(this.shadowComponent, 'anims', undefined);
        this.$set(this.shadowComponent, 'atlas', '');
        this.$set(this.shadowComponent, 'texture', data.image.id);
        this.$set(this.shadowComponent, 'sprite', data.image.id);
        this.$set(this.shadowComponent, 'firstLoad', true);
      } else if (type === 'spritesheet') {
        this.$set(this.shadowComponent, 'anim', false);
        this.$set(this.shadowComponent, 'anims', undefined);
        this.$set(this.shadowComponent, 'atlas', data.spritesheet.id);
        this.$set(this.shadowComponent, 'texture', data.image.name);
        this.$set(this.shadowComponent, 'sprite', data.image.name);
        this.$set(this.shadowComponent, 'firstLoad', true);
      }
      const nv = this.shadowComponent;

      this.onSave();
    },

    onClose() {
      this.$emit('close');
    },
    onSave() {
      const nv = this.shadowComponent;
      const ov = this.ov;
      Object.assign(this.component, this.shadowComponent);
      this.$emit('done', {
        ov,
        nv
      });
    }
  },
  components: {
    TextEditing,
    UnifiedSelect,
    Condensed
  },

  
}
</script>
